module.exports = new __parcel__URL__("periscope-page-with-insights.tpl.c866da13.svg").toString();